import { render, staticRenderFns } from "./ConsultantOrderDetails.vue?vue&type=template&id=8e9114ae"
import script from "./ConsultantOrderDetails.vue?vue&type=script&lang=js"
export * from "./ConsultantOrderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e9114ae')) {
      api.createRecord('8e9114ae', component.options)
    } else {
      api.reload('8e9114ae', component.options)
    }
    module.hot.accept("./ConsultantOrderDetails.vue?vue&type=template&id=8e9114ae", function () {
      api.rerender('8e9114ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/ConsultantOrderDetails.vue"
export default component.exports